const state = {
    deliverynotes: [],
    deliveryNoteid: [],
    deliverynotesByInvoice: [],
    signature: [],
    signatureid: [],
    loading: false
};

export default state;